// Import SASS
import '../sass/style.scss';

// Import scripts
import './modules/navigation';
import './modules/skip-link-focus-fix';
import objectFitImages from 'object-fit-images';
import { testimonialSlider } from './modules/sliders';
import faq from './modules/faq';
import { cartProcess } from './modules/cartProcess';
import video from './modules/video';

// Object-fit fix
objectFitImages();

testimonialSlider('.testimonial-slider');

const navs = document.querySelectorAll('.tns-nav');
for (let i = 0; i < navs.length; i++) {
    navs[i].parentNode.appendChild(navs[i]);
}

cartProcess('form.cart');

faq();

if ( document.querySelector('.video') ) {

    var videoDiv = document.querySelector('.video');
    var iframeHTML = document.getElementById('video__iframe').innerHTML;

    video(videoDiv, iframeHTML);

}